import { createApp, ref, onMounted } from "vue";
import CustomFieldInjector from "../Components/CustomFieldInjector.vue";

export default {
    setup(props) {
        const customFieldValues = ref({});

        const mapCustomFieldValues = (custom_field_values) => {
            custom_field_values.forEach((field) => {
                customFieldValues.value[field.custom_field_id] = field.value;
            });
        };

        if (Array.isArray(props.customFieldValues)) {
            mapCustomFieldValues(props.customFieldValues);
        }

        const injectorPlaceholder = props?.element;
        if (injectorPlaceholder) {
            if (!props.isMounted) {
                const injectorApp = createApp(CustomFieldInjector, {
                    modelType: props.customModelType || "App\\Models\\Entity",
                    position: props.customFieldPosition || 1,
                    customFieldValues: customFieldValues.value,
                    gridClass: props.gridClass,
                    onInput: (customValues) => {
                        if (customValues?.target) {
                            customFieldValues.value[customValues.target.id] =
                                customValues.target.value;
                        }
                    },
                });

                const injectorInstance = injectorApp.mount(
                    document.createElement("div")
                );
                injectorPlaceholder.appendChild(injectorInstance.$el);
            }
        }

        return {
            customFieldValues,
            mapCustomFieldValues,
        };
    },
    mounted() {
        if (Array.isArray(this.custom_field_values)) {
            this.mapCustomFieldValues(this.custom_field_values);
        }
        // Look for a designated element that should host custom fields.
        const injectorPlaceholder = this.$refs.customInjector;
        if (injectorPlaceholder) {
            // Create a Vue app for the injector component.
            const injectorApp = createApp(CustomFieldInjector, {
                modelType: this.customModelType || "App\\Models\\Entity",
                position: this.customFieldPosition || 1, // Default position is 1
                customFieldValues: this.customFieldValues,
                onInput: (customValues) => {
                    if (customValues?.target) {
                        this.customFieldValues[customValues.target.id] =
                            customValues.target.value; // Assign the exact input field value
                    }
                },
            });

            // Mount the app and append it to the placeholder element.
            const injectorInstance = injectorApp.mount(
                document.createElement("div")
            );
            injectorPlaceholder.appendChild(injectorInstance.$el);
        }
    },
    data() {
        return {
            customFieldValues: {}, // Initialize customFieldValues
        };
    },
    methods: {
        mapCustomFieldValues(custom_field_values) {
            custom_field_values.forEach((field) => {
                this.customFieldValues[field.custom_field_id] = field.value;
            });
        },
    },
};
